import { getType } from '@anm/helpers/saga/typesafe-actions';
import { Reducer } from 'redux';

import { initialVideoFolderState } from '..';
import { expandFolderInTree, fetchFolderTreeAsync } from '../../actions';
import { findAndUpdateFolder } from '../../helpers';
import { VideoFolderActions } from '../../types';

const folderTreeReducer: Reducer<typeof initialVideoFolderState, VideoFolderActions> = (
  state = initialVideoFolderState,
  action
) => {
  switch (action.type) {
    case getType(expandFolderInTree): {
      const { folderId, justOpen } = action.payload;

      return {
        ...state,
        folderTree: {
          ...state.folderTree,
          data: findAndUpdateFolder(
            state.folderTree.data!,
            folderId
          )(v => ({
            ...v,
            isExpanded: justOpen || !v.isExpanded
          })),
          isError: false,
          isPending: true
        }
      };
    }
    case getType(fetchFolderTreeAsync.request): {
      return {
        ...state,
        folderTree: {
          ...state.folderTree,
          isError: false,
          isPending: true
        }
      };
    }
    case getType(fetchFolderTreeAsync.success): {
      const folderTree = action.payload;
      folderTree.name = 'Projects';
      folderTree.isExpanded = true;

      return {
        ...state,
        folderTree: {
          ...state.folderTree,
          data: folderTree,
          isPending: false
        }
      };
    }
    case getType(fetchFolderTreeAsync.failure): {
      const error = action.payload;

      return {
        ...state,
        folderTree: {
          ...state.folderTree,
          error,
          isError: true,
          isPending: false
        }
      };
    }
    default:
      return state;
  }
};

export default folderTreeReducer;
